/* tslint:disable */

/* eslint-disable */

/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from "../runtime";
import { Topic, TopicFromJSON, TopicFromJSONTyped, TopicToJSON } from "./Topic";

/**
 *
 * @export
 * @interface TopicListResponse
 */
export interface TopicListResponse {
  /**
   *
   * @type {number}
   * @memberof TopicListResponse
   */
  offset: number;
  /**
   *
   * @type {number}
   * @memberof TopicListResponse
   */
  limit: number;
  /**
   *
   * @type {string}
   * @memberof TopicListResponse
   */
  order: string;
  /**
   *
   * @type {string}
   * @memberof TopicListResponse
   */
  sort: string;
  /**
   *
   * @type {number}
   * @memberof TopicListResponse
   */
  count: number;
  /**
   *
   * @type {Array<Topic>}
   * @memberof TopicListResponse
   */
  data: Array<Topic>;
}

export function TopicListResponseFromJSON(json: any): TopicListResponse {
  return TopicListResponseFromJSONTyped(json, false);
}

export function TopicListResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TopicListResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    offset: json["offset"],
    limit: json["limit"],
    order: json["order"],
    sort: json["sort"],
    count: json["count"],
    data: (json["data"] as Array<any>).map(TopicFromJSON),
  };
}

export function TopicListResponseToJSON(value?: TopicListResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    offset: value.offset,
    limit: value.limit,
    order: value.order,
    sort: value.sort,
    count: value.count,
    data: (value.data as Array<any>).map(TopicToJSON),
  };
}
